import { render } from "./navbar.vue?vue&type=template&id=0f8e2c49"
const script = {}

import "./navbar.vue?vue&type=style&index=0&id=0f8e2c49&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__